import { Link } from "react-router";
import { CONSTANTS } from "../../constants";
import { IMAGES } from "../../assets/images";

const NotFoundPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen text-center">
      <h1 className="text-6xl mb-4">הדף לא נמצא</h1>
      <img src={IMAGES.PAGE_NOT_FOUND} className="w-1/3" />
      <Link
        to={CONSTANTS.ROUTES.home}
        className="mt-6 text-blue-500 rounded border border-blue-500 px-4 py-4 hover:scale-110">
        חזור למסך הבית
      </Link>
    </div>
  );
};

export default NotFoundPage;
